import Vue from 'vue'
import App from './App.vue'
import './assets/reset.scss'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import store from './store/index';

/* swiper */
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

/* scroller */
import VueScroller from "vue-scroller"
Vue.use(VueScroller);

import vuetify from './plugins/vuetify';


Vue.config.productionTip = false
Vue.use(Antd);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title || '重庆巨通交通'
  }
  next()
  })
new Vue({
  router,
  store,

  data(){
    return {
      screenWidth:document.documentElement.offsetWidth || document.body.clientWidth,
    }
  },

  created(){
    if(this.screenWidth > 750){
      store.dispatch('isTarset',false);
    }else{
      store.dispatch('isTarset',true);
    }
  },

  mounted () {
    const that = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
        })()
    }
  },

  watch:{
    screenWidth(val){
        this.screenWidth = val
        if(val > 750){
          store.dispatch('isTarset',false);
        }else{
          store.dispatch('isTarset',true);
        }
    }
},
vuetify,
  render: h => h(App)
}).$mount('#app')
